import styled, { css } from 'styled-components/macro';
import ProfileImageComponent from '../../common/ProfileImage';
import { fontSize, fontWeight, lineHeight, space } from '../../../theme/tokens';
import { Whiteboard } from './Whiteboard.js';

export const DirectMessageWhiteboard = styled(Whiteboard)`
  flex-direction: row;
  gap: ${space[3]};
`;

export const ParticipantName = styled.h1`
  margin: 0;
  min-width: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;
`;

export const ParticipantRole = styled.h2`
  margin: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.classroomHighlight};
`;

export const ParticipantProfileImage = styled(ProfileImageComponent)`
  grid-area: image;
  align-self: center;
  justify-self: center;
  flex-shrink: 0;
  /* avatar size */
  height: 4rem;
  width: 4rem;
  margin: 0;

  ${({ isStaff }) =>
    isStaff &&
    css`
      border: 3px solid ${({ theme }) => theme.classroomHighlight};
      border-radius: 50%;
    `}
`;
